<template>
  <div class="input-container">
    <div v-if="loadingLayer" class="loading-input-cenario">
      <LoadingPadraoContainerMini delay="5000" />
    </div>
    <div v-if="tipo == 'texto'">
      <div :class="['input-container', { disabled: disabled }]">
        <input
          :tabindex="readonly || disabled ? '-1' : '0'"
          :readonly="readonly || disabled"
          :class="['input-class', { requerido: requerido }, { 'input-class-padding': readonly }]"
          v-if="mask"
          v-mask="mask"
          :placeholder="placeholder"
          ref="textInput"
          type="text"
          v-model="localModel"
        />
        <input
          :tabindex="readonly || disabled ? '-1' : '0'"
          :readonly="readonly || disabled"
          :class="['input-class', { requerido: requerido }, { 'input-class-padding': readonly }]"
          v-else-if="dinheiro"
          v-money="money"
          :placeholder="placeholder"
          ref="textInput"
          type="text"
          v-model="localModel"
        />
        <input
          :tabindex="readonly || disabled ? '-1' : '0'"
          :readonly="readonly || disabled"
          :class="['input-class', { requerido: requerido }, { 'input-class-padding': readonly }]"
          v-else
          ref="textInput"
          :placeholder="placeholder"
          type="text"
          v-model="localModel"
          :maxlength="maxlength"
        />
        <div v-if="cnpj">
          <div
            v-show="showClear && !(readonly || disabled)"
            @click="clearInput"
            @contextmenu.prevent="clearInput"
            class="input-icon input-icon-secondary"
          >
            <font-awesome-icon icon="times" />
          </div>
          <div
            v-if="cnpj.status == 'confirma'"
            v-b-tooltip.hover
            :title="cnpj.titulo"
            :class="['input-icon', 'cnae-loading', 'center']"
          >
            <font-awesome-icon icon="check" />
          </div>
          <div
            v-if="cnpj.status == 'alerta'"
            v-b-tooltip.hover
            :title="cnpj.titulo"
            :class="['input-icon', 'cnae-loading', 'center']"
          >
            <font-awesome-icon icon="exclamation" />
          </div>
          <div
            v-if="cnpj.status == 'vazio'"
            v-b-tooltip.hover
            :title="cnpj.titulo"
            :class="['input-icon', 'cnae-loading', 'center']"
          >
            <font-awesome-icon icon="times" />
          </div>
        </div>
        <div v-else>
          <div
            v-show="showClear && !(readonly || disabled)"
            @click="clearInput"
            @contextmenu.prevent="clearInput"
            class="input-icon"
          >
            <font-awesome-icon icon="times" />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="tipo == 'home'">
      <div
        :class="[
          'input-container',
          'input-container-home',
          { 'cnae-mod-padding': tipo == 'cnae' },
          { disabled: disabled }
        ]"
      >
        <input
          v-if="!mask"
          :tabindex="readonly || disabled ? '-1' : '0'"
          :readonly="readonly || disabled"
          :class="[
            'input-class',
            'input-class-change',
            { requerido: requerido },
            { 'input-class-padding': readonly }
          ]"
          ref="optionsInput"
          type="text"
          v-model="localModel"
          :placeholder="placeholderModified"
          @keydown.prevent.up="highlightIncrement(-1)"
          @keydown.prevent.down="highlightIncrement(1)"
          @keydown.enter="selectOption"
          @keydown.tab="selectTab"
          @keydown.esc="setBlurOptions"
          @focus="focus"
          @blur="blur"
        />
        <input
          v-else
          :tabindex="readonly || disabled ? '-1' : '0'"
          v-mask="mask"
          :readonly="readonly || disabled"
          :class="[
            'input-class',
            'input-class-change',
            { requerido: requerido },
            { 'input-class-padding': readonly }
          ]"
          ref="optionsInput"
          type="text"
          v-model="localModel"
          :placeholder="placeholderModified"
          @keydown.prevent.up="highlightIncrement(-1)"
          @keydown.prevent.down="highlightIncrement(1)"
          @keydown.enter="selectOption"
          @keydown.tab="selectTab"
          @keydown.esc="setBlurOptions"
          @focus="focus"
          @blur="blur"
        />
        <!-- <div
          v-show="showClear && !(readonly || disabled)"
          @click="clearInput"
          :class="['input-icon', 'input-container-home', { 'cnae-mod-secondary': tipo == 'cnae' }]"
        >
          <font-awesome-icon icon="times" />
        </div> -->
      </div>
      <div class="dropdown-container">
        <div
          @mouseover="holdBlur = true"
          @mouseleave="holdBlur = false"
          ref="dropdown"
          v-show="localModel.length >= minLengthDropdown && localModel.length < maxLengthDropdown"
          tabindex="0"
          class="options-dropdown options-dropdown-home"
          :style="maxHeight ? `max-height: ${maxHeight}px;` : ''"
        >
          <div
            v-if="
              !loadChange &&
                filteredOptions.length > 0 &&
                localModel.length >= (tipoBusca != 'GTIN' ? 2 : 8)
            "
          >
            <div
              v-for="(option, index) in filteredOptions"
              ref="dropdownOptions"
              :key="index"
              v-if="index < loadElement"
              :class="[
                'option-component',
                'home-option-component',
                { 'input-home-nao-vigente': option && option.vigente == 0 },
                { 'input-home-alterado': option && option.alterado == 1 },
                { 'align-left-input': alignLeft },
                { 'option-component-cnae': tipo == 'cnae' },
                { 'dropdown-highlighted': index === highlightedIndex },
                {
                  'dropdown-highlighted-alterado':
                    index === highlightedIndex && option && option.alterado == 1
                },
                {
                  'dropdown-highlighted-nao-vigente':
                    index === highlightedIndex && option && option.vigente == 0
                },
                { 'dropdown-no-selection': noSelection || (tipo == 'cnae' && option.header) }
              ]"
              @mouseover="highlightOption(index)"
              @click="selectOption"
              @contextmenu.prevent="selectOption"
              v-b-tooltip.hover.window.top
              :title="
                option && option.vigente == 0
                  ? 'NCM não vigente! Selecione esta opção para visualizar a NCM correspondente.'
                  : option && option.alterado == 1
                  ? 'NCM alterada! Selecione esta opção para visualizar a NCM correspondente.'
                  : ''
              "
            >
              <div v-if="option && filteredOptions.length > 0" :class="['input-home-dropdown']">
                <div class="input-home-ncm">
                  {{ option.ncm }}
                </div>
                <div class="input-home-descricao">{{ option.descricao }}</div>
              </div>
            </div>
            <div
              @click="handleClickBotaoResultados"
              @contextmenu.prevent="handleClickBotaoResultados"
              v-if="mostraBotaoResultados"
              class="home-resultados-botao"
            >
              Foram encontrados mais de 10 resultados com o termo pesquisado. Clique aqui para
              navegar entre eles.
            </div>
          </div>
          <div v-else-if="!loadChange" class="home-sem-opcoes" @click="homeNoOptions">
            {{
              tipoBusca != "GTIN" && localModel.length < 2
                ? "Informe ao menos 2 caracteres"
                : tipoBusca == "GTIN" && localModel.length < 8
                ? "Informe ao menos 8 caracteres"
                : noOptions
            }}
          </div>
          <div v-else>
            <LoadingPadraoContainer
              class="home-loading-ncm"
              :fraseLoading="['Carregando lista de NCMs', 'Aguarde um momento']"
              delay="5000"
              classe="azul"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="tipo == 'change'">
      <div
        :class="['input-container', { 'cnae-mod-padding': tipo == 'cnae' }, { disabled: disabled }]"
      >
        <input
          v-if="!mask"
          :tabindex="readonly || disabled ? '-1' : '0'"
          :readonly="readonly || disabled"
          :class="[
            'input-class',
            'input-class-change',
            { requerido: requerido },
            { 'input-class-padding': readonly }
          ]"
          ref="optionsInput"
          type="text"
          v-model="localModel"
          :placeholder="placeholderModified"
          @keydown.prevent.up="highlightIncrement(-1)"
          @keydown.prevent.down="highlightIncrement(1)"
          @keydown.enter="selectOption"
          @keydown.tab="selectTab"
          @keydown.esc="setBlurOptions"
          @focus="focus"
          @blur="blur"
        />
        <input
          v-else
          :tabindex="readonly || disabled ? '-1' : '0'"
          v-mask="mask"
          :readonly="readonly || disabled"
          :class="[
            'input-class',
            'input-class-change',
            { requerido: requerido },
            { 'input-class-padding': readonly }
          ]"
          ref="optionsInput"
          type="text"
          v-model="localModel"
          :placeholder="placeholderModified"
          @keydown.prevent.up="highlightIncrement(-1)"
          @keydown.prevent.down="highlightIncrement(1)"
          @keydown.enter="selectOption"
          @keydown.tab="selectTab"
          @keydown.esc="setBlurOptions"
          @focus="focus"
          @blur="blur"
        />
        <div
          v-show="showClear && !(readonly || disabled)"
          @click="clearInput"
          @contextmenu.prevent="clearInput"
          :class="['input-icon', { 'cnae-mod-secondary': tipo == 'cnae' }]"
        >
          <font-awesome-icon icon="times" />
        </div>
      </div>
      <div class="dropdown-container">
        <div
          @mouseover="holdBlur = true"
          @mouseleave="holdBlur = false"
          ref="dropdown"
          v-show="localModel.length >= minLengthDropdown && localModel.length < maxLengthDropdown"
          tabindex="0"
          class="options-dropdown"
          :style="maxHeight ? `max-height: ${maxHeight}px;` : ''"
        >
          <div v-if="!loadChange">
            <div
              v-for="(option, index) in filteredOptions"
              ref="dropdownOptions"
              :key="index"
              v-if="index < loadElement"
              :class="[
                'option-component',
                { 'align-left-input': alignLeft },
                { 'option-component-cnae': tipo == 'cnae' },
                { 'dropdown-highlighted': index === highlightedIndex },
                { 'dropdown-no-selection': noSelection || (tipo == 'cnae' && option.header) }
              ]"
              @mouseover="highlightOption(index)"
              @click="selectOption"
              @contextmenu.prevent="selectOption"
            >
              <div>
                {{ option }}
              </div>
            </div>
          </div>
          <div v-else><LoadingPadraoContainerMini delay="5000" /></div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        :class="['input-container', { 'cnae-mod-padding': tipo == 'cnae' }, { disabled: disabled }]"
      >
        <input
          v-if="!mask"
          :tabindex="readonly || disabled ? '-1' : '0'"
          :readonly="readonly || disabled"
          :class="['input-class', { requerido: requerido }, { 'input-class-padding': readonly }]"
          ref="optionsInput"
          type="text"
          v-model="localModel"
          :placeholder="placeholderModified"
          @keydown.prevent.up="highlightIncrement(-1)"
          @keydown.prevent.down="highlightIncrement(1)"
          @keydown.enter="selectOption"
          @keydown.tab="selectTab"
          @keydown.esc="setBlurOptions"
          @focus="focus"
          @blur="blur"
        />
        <input
          v-else
          :tabindex="readonly || disabled ? '-1' : '0'"
          v-mask="mask"
          :readonly="readonly || disabled"
          :class="['input-class', { requerido: requerido }, { 'input-class-padding': readonly }]"
          ref="optionsInput"
          type="text"
          v-model="localModel"
          :placeholder="placeholderModified"
          @keydown.prevent.up="highlightIncrement(-1)"
          @keydown.prevent.down="highlightIncrement(1)"
          @keydown.enter="selectOption"
          @keydown.tab="selectTab"
          @keydown.esc="setBlurOptions"
          @focus="focus"
          @blur="blur"
        />
        <div
          v-show="!(readonly || disabled)"
          @click="clickIcon"
          @contextmenu.prevent="clickIcon"
          @mouseover="holdBlur = true"
          @mouseleave="holdBlur = false"
          :class="[
            'input-icon',
            { 'input-icon-opened': showDropdown },
            { 'cnae-mod': tipo == 'cnae' }
          ]"
        >
          <font-awesome-icon icon="chevron-up" />
        </div>
        <div
          v-show="showClear && !(readonly || disabled)"
          @click="clearInput"
          @contextmenu.prevent="clearInput"
          :class="['input-icon', 'input-icon-secondary', { 'cnae-mod-secondary': tipo == 'cnae' }]"
        >
          <font-awesome-icon icon="times" />
        </div>
        <div v-if="tipo == 'cnae'">
          <div
            v-if="loading"
            v-b-tooltip.hover
            title="Carregando"
            :class="['input-icon-side', 'center']"
          >
            <LoadingPadraoContainerMini tamanho="20" delay="5000" />
          </div>
          <div
            v-else
            @click="handleClickIcon"
            @contextmenu.prevent="handleClickIcon"
            v-b-tooltip.hover
            title="Apenas CNAES de produtos estão disponíveis atualmente"
            :class="[
              'input-icon',
              'cnae-loading',
              { 'cnae-icon-disabled': localModel == '' },
              'center'
            ]"
          >
            <font-awesome-icon icon="exclamation" />
          </div>
        </div>
      </div>
      <div class="dropdown-container">
        <div
          @mouseover="holdBlur = true"
          @mouseleave="holdBlur = false"
          ref="dropdown"
          v-show="showDropdown"
          tabindex="0"
          class="options-dropdown"
          :style="maxHeight ? `max-height: ${maxHeight}px;` : ''"
        >
          <div
            v-for="(option, index) in filteredOptions"
            ref="dropdownOptions"
            :key="index"
            v-if="index < loadElement"
            :class="[
              'option-component',
              { 'align-left-input': alignLeft },
              { 'option-component-cnae': tipo == 'cnae' },
              { 'dropdown-highlighted': index === highlightedIndex },
              { 'dropdown-no-selection': noSelection || (tipo == 'cnae' && option.header) }
            ]"
            @mouseover="highlightOption(index)"
            @click="selectOption"
            @contextmenu.prevent="selectOption"
          >
            <div v-if="tipo == 'cnae'" class="cnae-option">
              <div v-if="option.ncm_indireta || option.ncm_direta">
                <div
                  v-if="highlightedIndex == index && option.label"
                  v-b-tooltip.hover.left.window
                  :title="tooltip(option)"
                  :class="[
                    'sphere',
                    { 'yellow-sphere': option.ncm_indireta == 1 },
                    { 'red-sphere': option.ncm_direta == 0 && option.ncm_indireta == 0 }
                  ]"
                ></div>
                <div
                  v-else
                  :class="[
                    'sphere',
                    { 'yellow-sphere': option.ncm_indireta == 1 },
                    { 'red-sphere': option.ncm_direta == 0 && option.ncm_indireta == 0 }
                  ]"
                ></div>
              </div>
              <span
                class="cnae-span"
                v-if="highlightedIndex == index && option.label"
                v-b-tooltip.hover.right.window
                :title="option.label ? option.label : ''"
              >
                {{ option.label ? option.label : option.header }}
              </span>
              <span v-else>
                {{ option.label ? option.label : option.header }}
              </span>
            </div>
            <div v-else>
              {{ option }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheMask from "vue-the-mask";
import vMoney from "v-money";
import stringFormatMixin from "@/mixins/stringFormatMixin";
import LoadingPadraoContainerMini from "@/components/LoadingPadrao/LoadingPadraoContainerMini.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  name: "CenarioInput",
  props: {
    nome: String,
    tipoBusca: String,
    maxlength: String,
    validaCampos: Object,
    loadingLayer: Boolean,
    exibeValidacao: Boolean,
    desativaTabSelect: Boolean,
    tipo: String,
    placeholder: String,
    noOptions: String,
    model: String | Number,
    minLengthDropdown: Number,
    maxLengthDropdown: Number,
    options: Array | Object,
    object: Array,
    mask: String,
    maxHeight: String | Number,
    cnpj: Object,
    mostraBotaoResultados: Boolean,
    loadChange: Boolean,
    noFilter: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    loading: Boolean,
    dinheiro: Boolean,
    alignLeft: Boolean,
    exibeTabelaBuscaNcmClick: Function,
    clickCnae: Function
  },
  components: {
    TheMask,
    vMoney,
    LoadingPadraoContainer,
    LoadingPadraoContainerMini
  },
  mixins: [stringFormatMixin],
  data() {
    return {
      noSelection: false,
      showDropdown: false,
      highlightedIndex: 0,
      holdBlur: false,
      placeholderModified: this.placeholder,
      localModelBackup: this.model,
      selected: "",
      loadElement: 50,
      bypassBlur: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },
  mounted() {
    if (this.$refs.dropdown) {
      this.$refs.dropdown.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    if (this.$refs.dropdown) {
      this.$refs.dropdown.addEventListener("scroll", this.handleScroll);
    }
  },
  watch: {
    placeholder() {
      if (this.tipo == "home") {
        this.placeholderModified = this.placeholder;
      }
    },
    model() {
      if (this.dinheiro) {
        this.localModel = this.model.replace("-", "");
      }
      if (this.tipo != "home") {
        this.localModelBackup = this.placeholderModified;
      } else {
        this.localModelBackup = "";
      }
      if (this.placeholderModified == "") {
        this.placeholderModified = this.placeholder;
      }
      this.noSelection = false;
    }
  },
  computed: {
    localModel: {
      get() {
        return this.model;
      },
      set(newValue) {
        this.$emit("update:model", newValue);
      }
    },
    requerido() {
      if (this.validaCampos && this.nome) {
        let requerido = !!Object.keys(this.validaCampos).includes(this.nome);
        return requerido && this.exibeValidacao;
      }
      return false;
    },
    filteredOptions() {
      if (this.tipo == "home") {
        if (this.localModel && !!this.localModel.length) {
          this.highlightedIndex = 0;
          return this.options;
          // let options =
          //   this.options && this.options.length
          //     ? this.options.filter(
          //         p =>
          //           p.ncm &&
          //           this.removerAcentos(
          //             p.ncm
          //               .replaceAll(" ", "")
          //               .replaceAll(".", "")
          //               .replaceAll("-", "")
          //               .replaceAll("/", "")
          //               .toLowerCase()
          //           ).includes(
          //             this.removerAcentos(
          //               this.localModel
          //                 .replaceAll(" ", "")
          //                 .replaceAll(".", "")
          //                 .replaceAll("-", "")
          //                 .replaceAll("/", "")
          //                 .toLowerCase()
          //             )
          //           )
          //       )
          //     : [];
          // this.noSelection = !!options.length ? false : true;
          // return !!options.length
          //   ? options
          //   : [this.noOptions ? this.noOptions.label : { label: "Sem opções disponíveis" }];
        }
        return [];
        // return this.options && this.options.length
        //   ? this.options
        //   : [this.noOptions ? this.noOptions.label : { label: "Sem opções disponíveis" }];
      } else if (this.tipo == "cnae") {
        if (this.localModel && !!this.localModel.length) {
          this.highlightedIndex = 0;
          let options =
            this.options && this.options.length
              ? this.options.filter(
                  p =>
                    p.label &&
                    this.removerAcentos(
                      p.label
                        .replaceAll(" ", "")
                        .replaceAll(".", "")
                        .replaceAll("-", "")
                        .replaceAll("/", "")
                        .toLowerCase()
                    ).includes(
                      this.removerAcentos(
                        this.localModel
                          .replaceAll(" ", "")
                          .replaceAll(".", "")
                          .replaceAll("-", "")
                          .replaceAll("/", "")
                          .toLowerCase()
                      )
                    )
                )
              : [];
          this.noSelection = !!options.length ? false : true;
          return !!options.length
            ? options
            : [this.noOptions ? this.noOptions.label : { label: "Sem opções disponíveis" }];
        }
        return this.options && this.options.length
          ? this.options
          : [this.noOptions ? this.noOptions.label : { label: "Sem opções disponíveis" }];
      } else if (this.noFilter) {
        if (!!this.localModel.length) {
          this.highlightedIndex = 0;
          let options = this.options && this.options.length ? this.options : [];
          // return options
          this.noSelection = !!options.length ? false : true;
          return !!options.length
            ? options
            : [this.noOptions ? this.noOptions : "Sem opções disponíveis"];
        }
        return this.options && this.options.length
          ? this.options
          : [this.noOptions ? this.noOptions : "Sem opções disponíveis"];
      } else {
        if (!!this.localModel.length) {
          this.highlightedIndex = 0;
          let options =
            this.options && this.options.length
              ? this.options.filter(p =>
                  this.removerAcentos(
                    p
                      .replaceAll(" ", "")
                      .replaceAll(".", "")
                      .toLowerCase()
                  ).includes(
                    this.removerAcentos(
                      this.localModel
                        .replaceAll(" ", "")
                        .replaceAll(".", "")
                        .toLowerCase()
                    )
                  )
                )
              : [];
          // return options
          this.noSelection = !!options.length ? false : true;
          return !!options.length
            ? options
            : [this.noOptions ? this.noOptions : "Sem opções disponíveis"];
        }
        return this.options && this.options.length
          ? this.options
          : [this.noOptions ? this.noOptions : "Sem opções disponíveis"];
      }
    },
    showClear() {
      if (this.localModel != "") {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleScroll(event) {
      if (
        event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 100 &&
        this.filteredOptions.length > this.loadElement
      ) {
        this.loadElement += 50;
      }
    },
    highlightOption(index) {
      this.highlightedIndex = index;
    },
    highlightIncrement(increment) {
      this.highlightedIndex += increment;

      if (this.filteredOptions.length <= this.loadElement) {
        this.highlightedIndex < 0
          ? (this.highlightedIndex = this.filteredOptions.length - 1)
          : this.highlightedIndex;
        this.highlightedIndex > this.filteredOptions.length - 1
          ? (this.highlightedIndex = 0)
          : this.highlightedIndex;
      } else {
        this.highlightedIndex < 0 ? (this.highlightedIndex = 0) : this.highlightedIndex;
        this.highlightedIndex > this.filteredOptions.length - 1
          ? (this.highlightedIndex = 0)
          : this.highlightedIndex;
      }

      if (
        this.filteredOptions[this.highlightedIndex] &&
        this.filteredOptions[this.highlightedIndex].header
      ) {
        this.highlightedIndex > 0
          ? (this.highlightedIndex += increment)
          : (this.highlightedIndex += 1);
      }
      if (this.$refs.dropdownOptions[this.highlightedIndex]) {
        this.$refs.dropdownOptions[this.highlightedIndex].scrollIntoView({
          behavior: "auto",
          block: "nearest",
          inline: "center"
        });
      }
    },
    selectOption() {
      if (this.loadChange) return;
      this.holdBlur = false;
      if (this.filteredOptions.length == 0) {
        this.blur();
        return;
      }
      if (this.noSelection || !!this.filteredOptions[this.highlightedIndex].header) {
        this.bypassBlur = true;
        this.$nextTick(() => {
          this.$refs.optionsInput.blur();
          this.blur();
        });
        return;
      }
      this.showDropdown = false;
      let options = this.noOptions ? this.noOptions : "Sem opções disponíveis";

      if (this.filteredOptions == options) return;

      this.$refs.optionsInput.blur();
      this.localModel = this.filteredOptions[this.highlightedIndex];
      this.localModelBackup = this.filteredOptions[this.highlightedIndex];
      this.selected = this.filteredOptions[this.highlightedIndex];
      this.$nextTick(() => {
        this.$emit("selected", this.localModel);
      });
    },
    focus() {
      if (this.readonly || this.disabled) return;

      this.showDropdown = true;
      this.highlightedIndex = 0;
      this.localModel = "";
      this.loadElement = 50;

      if (this.model != "") this.placeholderModified = this.model;

      this.$nextTick(() => {
        if (this.$refs.dropdownOptions && this.$refs.dropdownOptions[this.highlightedIndex]) {
          this.$refs.dropdownOptions[this.highlightedIndex].scrollIntoView({
            behavior: "auto",
            block: "nearest",
            inline: "center"
          });
        }
      });
    },
    setBlurOptions() {
      this.$refs.optionsInput.blur();
    },
    blur() {
      if (this.readonly || this.disabled) return;

      if (!this.holdBlur || this.bypassBlur) {
        this.$nextTick(() => {
          this.showDropdown = false;
          // if (this.tipo == "cnae") {
          //   this.localModel = this.localModelBackup ? this.localModelBackup.label : "";
          // } else {
          if (this.localModelBackup != this.placeholder) {
            this.localModel = this.localModelBackup;
          } else {
            this.localModel = "";
          }
          // }
          this.placeholderModified = this.placeholder;
          this.bypassBlur = false;
        });
      }
    },
    clickIcon() {
      if (!this.showDropdown) {
        this.holdBlur = true;
        this.$refs.optionsInput.focus();
      } else {
        this.$nextTick(() => {
          this.holdBlur = false;
          this.blur();
        });
      }
    },
    clearInput() {
      this.placeholderModified = this.placeholder;
      this.selected = "";
      this.$emit("selected", "");
      this.$nextTick(() => {
        this.localModelBackup = this.model;
        this.localModel = "";
      });
    },
    handleClickIcon() {
      if (this.localModel == "") return;
      this.clickCnae();
    },
    tooltip(option) {
      if (option.ncm_indireta == 1) {
        return "Outra NCM da lista possui vínculo com este CNAE.";
      }
      if (option.ncm_direta == 0 && option.ncm_indireta == 0) {
        return "Nenhuma NCM da lista possui vinculo com este CNAE.";
      }
      return "O NCM selecionado possui vínculo com este CNAE.";
    },
    selectTab() {
      if (this.desativaTabSelect) return;

      this.$nextTick(() => {
        this.selectOption();
      });
    },
    homeNoOptions() {
      this.localModel = "";
      this.placeholderModified = this.placeholder;
      this.$refs.optionsInput.blur();
    },
    handleClickBotaoResultados() {
      this.exibeTabelaBuscaNcmClick();
      this.holdBlur = false;
      this.blur();
    }
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  width: 100%;
  position: relative;
}
.input-class {
  transition: border 0.5s ease-in-out;
  height: 30px;
  padding: 0.3rem 3.5rem 0.3rem 0.8rem;
  width: 100%;
  border: 1px solid var(--cinza-borda);
  box-shadow: 2px 2px 4px var(--sombra0);
  &:focus {
    border: 1px solid var(--azul2);
  }
}
.input-class-padding {
  padding-right: 0.8rem;
}
.input-class-change {
  padding-right: 1.5rem;
}
.dropdown-container {
  position: relative;
}
.option-component {
  padding: 3px 20px;
  cursor: pointer;
  // height: 25px;
  overflow: hidden;
  &:nth-child(even) {
    background: var(--cinza0);
  }
}
.align-left-input {
  text-align: left;
}
.option-component-cnae {
  height: 25px;
}
.options-dropdown {
  position: absolute;
  top: 0;
  background: var(--branco);
  z-index: 1000;
  width: 100%;
  border: 1px solid var(--cinza-borda);
  border-top: 2px solid var(--cinza-borda);
  padding: 5px 0;
  max-height: 365px;
  overflow-y: auto;
  scroll-behavior: auto;
  box-shadow: 2px 2px 4px var(--sombra1);
  .input-home-nao-vigente {
    color: var(--vermelho3);
    background: #f5e3e3;
  }
  .input-home-alterado {
    color: var(--amarelo3);
    background: #f3f3db;
  }
  .dropdown-highlighted {
    background: var(--azul1);
    color: var(--branco);
  }
  .dropdown-no-selection {
    background: var(--branco);
    color: var(--preto);
  }
}
.dropDown-enter-active,
.dropDown-leave-active {
  transition: all 0.15s ease-in-out;
  z-index: 1000;
}
.dropDown-enter,
.dropDown-leave-to {
  max-height: 0;
}
.input-icon-side {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: var(--cinza2);
  font-size: 15px;
  user-select: none;
  height: 20px;
  width: 20px;
  margin: 5px 4px;
}
.input-icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 25px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: rotate 0.2s ease;
  rotate: -180deg;
  color: var(--cinza2);
  font-size: 15px;
  user-select: none;
}
.input-icon-opened {
  rotate: 0deg;
}
.input-icon-secondary {
  right: 25px;
}
.cnae-option {
  display: flex;
  div {
    display: flex;
    // align-items: center;
    // justify-content: center;
  }
}
.sphere {
  height: 14px;
  width: 14px;
  margin: 2px 10px 2px 0;
  border-radius: 50%;
  background: var(--verde2);
  box-shadow: 1px 1px 2px var(--sombra2);
}
.green-sphere {
  background: var(--verde2);
}
.yellow-sphere {
  background: var(--amarelo2);
}
.red-sphere {
  background: var(--vermelho2);
}
.cnae-mod {
  right: 26px;
}
.cnae-mod-secondary {
  right: 50px;
}
.cnae-mod-padding {
  input {
    padding-right: 5.3rem;
  }
}
.cnae-loading {
  border-radius: 50%;
  border: 2px solid var(--cinza2);
  height: 20px;
  width: 20px;
  margin: 5px 4px;
  font-size: 10px;
  rotate: 0deg;
}
.cnae-icon-disabled {
  color: var(--cinza02);
  border: 2px solid var(--cinza02);
  cursor: default;
}
.requerido {
  border: 1px solid var(--vermelho2);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    height: 10px;
    width: 10px !important;
  }
}
.cnae-span {
  height: 20px;
}
.disabled {
  background: var(--cinza01);
}
.loading-input-cenario {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--backdrop);
  color: var(--branco);
}
.input-container-home {
  height: 40px;
  input {
    height: 40px;
  }
}
.input-home-dropdown {
  display: flex;
  white-space: nowrap;
  overflow: hidden;
}
.input-home-ncm {
  font-weight: bold;
  margin: 0 10px;
}
.input-home-descricao {
  margin: 0 10px;
}
.home-option-component {
  padding: 8px;
  margin: 1px 0;
  height: 34px;
  background: var(--cinza0);
}
.options-dropdown-home {
  max-height: 400px;
  padding: 0;
  .dropdown-highlighted {
    background: #cecece;
    color: var(--preto);
  }
  .dropdown-no-selection {
    background: var(--branco);
    color: var(--preto);
  }
  .dropdown-highlighted-nao-vigente {
    background: #cebdbd;
    color: var(--vermelho3);
  }
  .dropdown-highlighted-alterado {
    background: #ccccb9;
    color: var(--amarelo3);
  }
}
.home-sem-opcoes {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
}
.home-resultados-botao {
  cursor: pointer;
  display: flex;
  height: 34px;
  align-items: center;
  justify-content: center;
  background: var(--azul0);
  color: var(--azul2);
  // border-top: 1px solid var(--azul2);
  // border-bottom: 1px solid var(--azul2);
}
.home-loading-ncm {
  margin: 10px;
}
</style>
